import React from 'react';
import NotesMainPanel from '../../components/workspace/NotesMainPanel';
import { useDashboardData } from '../../components/DashboardShell';
import { useLocale } from '../../context/LocaleContext';

export default function BonniePlayground() {
  const { data } = useDashboardData();
  const { t } = useLocale();
  const items = data?.bonnie?.playground || [];
  return (
    <NotesMainPanel
      title={t('bonnie.playgroundTitle')}
      subtitle={t('bonnie.playgroundSubtitle')}
      items={items}
      emptyTitle={t('bonnie.playgroundEmpty')}
    />
  );
}
